import { AUTH_FAIL, AUTH_REFRESH_FAIL, AUTH_REFRESH_SUCCESS, AUTH_START, AUTH_SUCCESS } from '../actions/actionTypes';
import { TRACK_ANALYTICS } from '../actions/trackAnalytics';
import { analytics } from '../utils/analytics';

const trackingMiddleware = (_store: any) => (next: (_: any) => any) => (action: any) => {
  switch (action?.type) {
    
    case TRACK_ANALYTICS:
      analytics.trackEvent('track_analytics', action);
      break;

    case AUTH_START:
      analytics.trackEvent('auth_start', action);
      break;

    case AUTH_SUCCESS:
      analytics.trackEvent('auth_success', action);
      break;

    case AUTH_FAIL:
      analytics.trackEvent('auth_fail', action);
      break;

    case AUTH_REFRESH_SUCCESS:
      analytics.trackEvent('auth_refresh_success', action);
      break;
  
    case AUTH_REFRESH_FAIL:
      analytics.trackEvent('auth_refresh_fail', action);
      break;

    default:
      console.debug("[trackingMiddleware] - ignored action", action?.type, action)
  }

  return next(action);
};

export default trackingMiddleware;